import { atom } from "@reatom/framework";

export type AdminUserSection = "overview" | "rights" | "subscribes" | "orders";

export const selectedSection = atom<AdminUserSection>(
  "overview",
  "selectedSection",
);
